import { defineStore } from "pinia";
import * as choiceApi from "../ChoiceApi"
import { DatabaseIdTypes } from "../../Enums/ChoiceEnums";
import { PatientHeaderBasicInfoModel } from "../Api/Patient";

export const usePatientsStore = defineStore('PatientsStore', () => {

    // FUTURE: Reconsider if we should pass schedule_date
    async function getBasicPatientInfo(id: number, idType: DatabaseIdTypes.patient_id|DatabaseIdTypes.patient_entity_id|DatabaseIdTypes.entity_id, schedule_date?: string)
        : Promise<PatientHeaderBasicInfoModel | undefined> 
    {
        const key = `${idType}:${id}:${schedule_date}`;

        if (!basicPatientInfo[key])
        {
            basicPatientInfo[key] = await choiceApi.patient.getPatientHeaderBasicInfo(id, idType, schedule_date);
        }
        return basicPatientInfo[key];
    }
    const basicPatientInfo: Record<string, PatientHeaderBasicInfoModel|undefined> = {};

    return { getBasicPatientInfo }
});
